﻿<template>
    <span>{{ float(computedValue, 2) }} {{ label }}</span>
</template>
<script>
    import utils from "../utils/units";
    import * as common from "../utils/common";
    import { mapState, mapGetters } from 'vuex';
    export default {
        props: ['value'],
        computed: {
            ...mapState(["currentUser"]),
            ...mapGetters(["isMetric"]),
            computedValue() {
                return this.isMetric ? this.value : utils.toOz(this.value);
            },
            label() {
                return utils.gramLabel(this.isMetric);
            }
        }
    }
</script>